var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"show-add-button":false,"popup-component":_vm.popupComponent,"sort":"order_id","descending":true,"title":"Order List","icon":"mdi-briefcase","stateendpoint":"order.orders","actions":_vm.actions,"show-default-action-buttons":false,"action-buttons":_vm.actionButtons}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }